const getAllSteps = state => {
  if (!state?.allSteps || !Array.isArray(state?.allSteps)) return [];

  return state.allSteps.filter(step => !step?.isDisabled);
};

export default getAllSteps;
